import React, { useEffect, useContext } from 'react';
import {
  MAX_MOBILE_WIDTH,
  SOURCE_AND_DEVICE_TYPE,
} from '../../constants';
import { ResizeContext } from '../../contexts/Resize/Resize';
import { HeaderDynamicContext } from '../../contexts/HeaderDynamicData/HeaderDynamicData';
import {
  getSourceAndDeviceType,
  isNotLoginOrRegisterPath,
} from '../../helpers';
import { getDeviceByWidth } from '../../helpers/getSourceAndDeviceType/getSourceAndDeviceType';
import Header from './Header';
import UseSyncSoComAffiliateWithBag from '../../hooks/UseSyncSoComAffiliateWithBag/UseSyncSoComAffiliateWithBag';
import UseCommissionJunction from '../../hooks/UseCommissionJunction/UseCommissionJunction';

function HeaderVM() {
  const { width } = useContext(ResizeContext);
  const { orderSummary } = useContext(HeaderDynamicContext);
  const { pathname } = window.location;
  const deviceWidth = getDeviceByWidth(width, MAX_MOBILE_WIDTH);
  const memberWalletHeader = window?.FLAGS?.MemberWallet || false;
  const memberWalletEnhancement =
    window?.FLAGS?.MemberWalletEnhancement || false;
  const addToBagFlyoutEnabled = window?.FLAGS?.AddToBagFlyout || false;

  useEffect(() => {
    const isValidPathname = isNotLoginOrRegisterPath(pathname);
    if (isValidPathname) {
      const sourceAndDeviceType = getSourceAndDeviceType(
        SOURCE_AND_DEVICE_TYPE,
        deviceWidth,
        window.location.pathname,
      );
      window.sessionStorage.setItem(
        'OriginRoutePathnameToCreate',
        sourceAndDeviceType,
      );
    }
  }, [deviceWidth, pathname]);

  // TODO: DEPRECATE THE FOLLOWING HOOK AFTER COMMISSION JUNCTION IS NO LONGER USED
  UseCommissionJunction(orderSummary);
  UseSyncSoComAffiliateWithBag();

  return (
    <Header
      memberWalletHeader={memberWalletHeader}
      memberWalletEnhancement={memberWalletEnhancement}
      addToBagFlyoutEnabled={addToBagFlyoutEnabled}
    />
  );
}

export default HeaderVM;
